<section class="creation-form">
  <button
    *ngIf="!isCreationMode"
    (click)="onEdit()"
    [matTooltip]="'repository.sites.list.add' | translate"
    mat-mini-fab
    class="action-button"
    color="primary"
  >
    <mat-icon aria-label="Add">add</mat-icon>
  </button>
  <app-site-edit
    *ngIf="isCreationMode && !editedId"
    (editFinished)="onEditFinished()"
  ></app-site-edit>
</section>

<mat-form-field class="filterField">
  <mat-label>Filtrer</mat-label>
  <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Votre filtre"
    #input
  />
</mat-form-field>

<section class="datatable-container">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.sites.list.name" | translate }}
      </th>
      <td mat-cell *matCellDef="let site">{{ site.name }}</td>
    </ng-container>

    <ng-container matColumnDef="client">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.sites.list.client" | translate }}
      </th>
      <td mat-cell *matCellDef="let site">
        <ul>
          <li *ngFor="let client of site.clients">{{ client.name }}</li>
        </ul>
      </td>
    </ng-container>

    <ng-container matColumnDef="otherSite">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.sites.list.otherSite" | translate }}
      </th>
      <td mat-cell *matCellDef="let site" class="otherSiteCell">
        {{ "boolean." + site.otherSite | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="documentUrl">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.sites.list.documentUrl" | translate }}
      </th>
      <td mat-cell *matCellDef="let site">{{ site.documentUrl }}</td>
    </ng-container>

    <ng-container matColumnDef="siren">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Siren</th>
      <td mat-cell *matCellDef="let site">{{ site.siren }}</td>
    </ng-container>

    <ng-container matColumnDef="options">
      <th mat-header-cell *matHeaderCellDef>
        {{ "repository.sites.list.options" | translate }}
      </th>
      <td mat-cell *matCellDef="let site">
        <span class="site-options">
          <span class="site-option">
            <mat-icon
              *ngIf="site.allowOtherAddress === true"
              color="primary"
              [attr.aria-label]="
                'repository.sites.list.allowOtherAddressEnabled' | translate
              "
              [matTooltip]="
                'repository.sites.list.allowOtherAddressEnabled' | translate
              "
            >
              location_on
            </mat-icon>
            <mat-icon
              *ngIf="site.allowOtherAddress === false"
              class="site-option-disabled"
              [attr.aria-label]="
                'repository.sites.list.allowOtherAddressDisabled' | translate
              "
              [matTooltip]="
                'repository.sites.list.allowOtherAddressDisabled' | translate
              "
            >
              location_off
            </mat-icon>
            <mat-icon
              *ngIf="site.allowOtherAddress == null"
              color="primary"
              [attr.aria-label]="
                'repository.sites.list.allowOtherAddressInherited' | translate
              "
              [matTooltip]="
                'repository.sites.list.allowOtherAddressInherited' | translate
              "
            >
              account_tree
            </mat-icon>
          </span>
          <span class="site-option">
            <mat-icon
              *ngIf="site.transmissionOnly"
              color="primary"
              [attr.aria-label]="
                'repository.sites.list.transmissionOnly' | translate
              "
              [matTooltip]="
                'repository.sites.list.transmissionOnly' | translate
              "
            >
              send
            </mat-icon>
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        {{ "repository.sites.list.actions" | translate }}
      </th>
      <td mat-cell *matCellDef="let site">
        <ng-container *ngIf="site.id !== editedId">
          <button
            mat-icon-button
            class="action-button"
            color="primary"
            [disabled]="isLoading"
            [matTooltip]="'repository.sites.list.edit' | translate"
            (click)="onEdit(site.id)"
          >
            <mat-icon aria-label="Edit">edit</mat-icon>
          </button>
        </ng-container>
        <ng-container>
          <button
            mat-icon-button
            class="action-button"
            color="primary"
            [disabled]="isLoading"
            [matTooltip]="'repository.sites.list.delete' | translate"
            (click)="delete(site.id)"
          >
            <mat-icon aria-label="Delete">delete</mat-icon>
          </button>
        </ng-container>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let site"
        [attr.colspan]="displayedColumns.length"
      >
        <div
          *ngIf="site.id === editedId"
          class="row-edit"
          [@detailExpand]="site.id === editedId ? 'expanded' : 'collapsed'"
        >
          <app-site-edit
            [site]="site"
            (editFinished)="onEditFinished()"
          ></app-site-edit>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="row"
      [ngClass]="{ 'expanded-row': row.id === editedId }"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="detail-row"
    ></tr>
  </table>
  <mat-paginator
    class="paginator"
    [pageSizeOptions]="[20, 25, 50, 100]"
    showFirstLastButtons
  ></mat-paginator>
</section>
<mat-progress-bar
  *ngIf="isLoading"
  class="progress-bar"
  mode="indeterminate"
  color="primary"
></mat-progress-bar>
